import TableTools from "@/utils/tableTools";
import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import {
  calculatedColumnsEnum,
  alternativeColumnLabelEnum,
} from "@/model/columnsEnums";
import _ from "lodash";

export const gamesHelper = {
  dimensions: [
    dimensionEnum.GAME,
    dimensionEnum.GAME_NAME,
    dimensionEnum.GAME_GAMECATEGORYID,
    dimensionEnum.GAMECATEGORY_NAME,
    dimensionEnum.GAME_CODE,
    dimensionEnum.GAME_TOKENPRICEASDIMENSION,
    dimensionEnum.SMARTTOUCH_NUMBER,
    dimensionEnum.SITE,
    dimensionEnum.SITE_NAME,
    dimensionEnum.GAMEHISTORY_TAXESPERCENT,
    dimensionEnum.SITE_CURRENCY
  ],

  getQueries(filters, timeDimension) {
    // Penser à reporter les modifications dans les preaggregations des GameHistory (MBA.KeyPlay.Reporting.BackEnd\schema\GameHistory.js).
    const filterQueryGameHistory = this.optimizeDateFilter(filters, dimensionEnum.GAMEHISTORY_DATE);
    const queries = [
      {
        query: {
          measures: [
            mesureEnum.GAMEHISTORY_TOKEN_PRICE,
            mesureEnum.GAMEHISTORY_TOKEN_PRICE_HT,
            mesureEnum.GAMEHISTORY_COUNT,
            mesureEnum.GAMEHISTORY_TOKEN,
            mesureEnum.GAMEHISTORY_BONUSTOKEN,
            mesureEnum.GAMEHISTORY_BONUSTOKEN_PRICE_HT
          ],
          dimensions: this.dimensions,
          timeDimensions: timeDimension
            ? [{ ...timeDimension, dimension: dimensionEnum.GAMEHISTORY_DATETIME }]
            : [],
          filters: [
            ...filterQueryGameHistory,
          ]
        },
      },
      // Récupération de tous les jeux même s'ils n'ont pas eu d'activité
      {
        query: {
          measures: [],
          dimensions: this.dimensions,
          filters: [
            filters.find((filter) => filter.dimension === dimensionEnum.SITE),
            TableTools.Helper.getFilterGameNotDeleted(),
            TableTools.Helper.getFilterSmarttouchNotDeleted(),
          ],
        },
      }
    ];
    return queries;
  },
  getStaffNumberGamesQueries(filters, timeDimension) {
    const filterQueryStaffGameHistory = this.optimizeDateFilter(filters, dimensionEnum.STAFFGAMEHISTORY_DATE);

    return {
      dimensions: [
        dimensionEnum.SITE,
        dimensionEnum.STAFFGAMEHISTORY_EVENTDATE,
        dimensionEnum.SMARTTOUCH_NUMBER,
      ],
      timeDimensions: timeDimension ? [timeDimension] : [],
      filters: filterQueryStaffGameHistory,
    };
  },
  optimizeDateFilter(filters, dimension) {
    // Filtre de date sur la clé étrangère pour éviter le Left Join avec la table BusinessDate
    const updatedFilters = JSON.parse(JSON.stringify(filters));
    const index = filters.findIndex(filter => filter.dimension == dimensionEnum.DATE)
    if (index !== -1) {
      updatedFilters[index].dimension = dimension
    }
    return updatedFilters
  },
  addCalculatedColumns(
    dataTable,
    totalRevenue,
    isGameCodeView = false
  ) {
    let completeDataTable = dataTable.map((data) => {
      const gameRevenue = data[mesureEnum.GAMEHISTORY_TOKEN_PRICE_HT] || 0;
      data[calculatedColumnsEnum.PERCENT_REVENUE_PER_GAME] = totalRevenue
        ? (gameRevenue * 100) / totalRevenue
        : 0;
      const bonusToken = data[mesureEnum.GAMEHISTORY_BONUSTOKEN] || 0;
      const token = data[alternativeColumnLabelEnum.GAMEHISTORY_TOKEN] || 0;
      const totalTokens = bonusToken + token;
      data[calculatedColumnsEnum.PERCENT_BONUS_TOKEN] = totalTokens !== 0
        ? (bonusToken * 100) / totalTokens
        : 0;

      const popularityByRevenue =
        (data[mesureEnum.GAMEHISTORY_TOKEN_PRICE_HT] || 0) +
        (data[mesureEnum.GAMEHISTORY_BONUSTOKEN_PRICE_HT] || 0)
      data[calculatedColumnsEnum.POPULARITY] = popularityByRevenue
        ? popularityByRevenue
        : 0;

      return data;
    });

    // Tri par revenu HT décroissant
    completeDataTable = _.orderBy(
      completeDataTable,
      (data) => data[mesureEnum.GAMEHISTORY_TOKEN_PRICE_HT] ?? -Infinity,
      'desc'
    );

    var i = 1;
    completeDataTable.forEach((data) => {
      // On n'attribue pas de rang aux lignes de groupes, différenciées par un nom de jeu vide
      if (data.groupLevel === undefined || isGameCodeView) {
        data[calculatedColumnsEnum.RANK] = i;
        i++;
      }
    });

    return completeDataTable;
  },
  /**
   * La requête qui récupère tous les jeux, même sans activité, fait apparaître des anomalies.
   * Certaines associations [n° d'élisa - n° de répertoire - taux de tva]
   * qui ont eu une activité antérieurement à la plage de date sélectionnée mais qui ne sont plus d'actualité,
   * sont quand même merge au résultat final provoquant des lignes avec des n° d'élisa en doublon.
   */
  sortAnomalies(results) {
    const cleanedResultsMap = new Map();

    for (const result of results) {
      const serialNumber = result[dimensionEnum.SMARTTOUCH_NUMBER];
      if (!serialNumber) continue;

      if (!cleanedResultsMap.has(serialNumber)) {
        cleanedResultsMap.set(serialNumber, []);
      }
      cleanedResultsMap.get(serialNumber).push(result);
    }

    const cleanedResults = [];

    for (const [, group] of cleanedResultsMap) {
      if (group.length === 1) {
        cleanedResults.push(group[0]);
        continue;
      }

      // Parmis les lignes qui possèdent des n° d'élisa en doublon :
      const withCount = group.filter(item => item[mesureEnum.GAMEHISTORY_COUNT] > 0);
      if (withCount.length > 0) {
        // On garde seulement celles qui ont eu de l'activité.
        cleanedResults.push(...withCount);
      } else {
        /**
         * Si aucune ligne n'a eu d'activité, on garde quand même une ligne
         * afin de garder l'impact de la requête qui récupère tous les jeux même sans activité.
         * Cette situation est très à la marge.
         */
        cleanedResults.push(group[0]);
      }
    }

    return cleanedResults;
  },
};
